import { all, SagaIterator, takeEveryCompletedRequest } from 'acscp/sagas/core/sagaEffects';
import { PasswordTokenRequest } from 'acscp/api/requests';
import { Capacitor } from '@capacitor/core';
import { SavePassword } from 'capacitor-ios-autofill-save-password';

export function* iOSPasswordSavePromptSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(PasswordTokenRequest, handleSuccessfulPasswordLogin),
    ]);
}

export function* handleSuccessfulPasswordLogin(
    response: any,
    request: PasswordTokenRequest
): SagaIterator {
    if (Capacitor.getPlatform() === 'ios') {
        void SavePassword.promptDialog({
            username: request.username,
            password: request.password,
        });
    }
}
